import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const SCOSTAMENTO = {
  top: "calc(var(--safe-area-top, 0px) + 12px)",
  right: "12px",
  bottom: "calc(var(--safe-area-bottom, 0px) + 12px)",
  left: "12px",
};

/**
 * Gli avvisi dell'app.
 *
 * Lo scostamento va dato due volte. Sotto i 600 pixel sonner smette di leggere
 * `offset` e passa a `mobileOffset`, che di suo vale 16 pixel fissi: sul telefono
 * la safe area veniva ignorata e gli avvisi finivano sotto l'orologio e la tacca.
 * Le due proprietà portano lo stesso valore, così il comportamento è identico
 * ovunque.
 *
 * Il disegno è quello delle card dell'app — bianco, angoli larghi, ombra
 * profonda — invece dei colori pieni di sonner, che dentro questa app
 * sembravano di un'altra applicazione. Il tipo di messaggio lo dice l'icona,
 * colorata da index.css.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-center"
      offset={SCOSTAMENTO}
      mobileOffset={SCOSTAMENTO}
      gap={10}
      duration={4500}
      style={{ zIndex: 100000, ["--width" as string]: "min(calc(100vw - 24px), 400px)" }}
      toastOptions={{
        style: { zIndex: 100000 },
        classNames: {
          toast: "arreda-toast",
          title: "arreda-toast-titolo",
          description: "arreda-toast-testo",
          actionButton: "arreda-toast-azione",
          cancelButton: "arreda-toast-annulla",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
